import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const GlobeUKIcon = observer('GlobeUKIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='16'
            height='16'
            viewBox='0 0 16 16'
            fill='none'
            className={className}
            onClick={onClick}
        >
            <mask
                id='globeUKMask'
                width='14'
                height='14'
                x='1'
                y='1'
                maskUnits='userSpaceOnUse'
                style={{ maskType: 'alpha' }}
            >
                <path
                    fill='#1c1b1f'
                    d='M8 13.333a4.8 4.8 0 0 0 1.133-.133l-.8-1.2H6v-.667q0-.55.392-.941.391-.392.941-.392h1.334V8H7.333a.65.65 0 0 1-.475-.192.65.65 0 0 1-.191-.475V6h-.3q-.434 0-.734-.292a.97.97 0 0 1-.3-.725A1.1 1.1 0 0 1 5.5 4.4l1.033-1.517a5.3 5.3 0 0 0-2.775 1.884Q2.667 6.166 2.667 8h.666v-.667q0-.283.192-.475A.65.65 0 0 1 4 6.667h1.333q.284 0 .475.191A.65.65 0 0 1 6 7.333V8a.65.65 0 0 1-.192.475.65.65 0 0 1-.475.192v.666q0 .55-.391.942a1.28 1.28 0 0 1-.942.392h-.617A5.4 5.4 0 0 0 5.3 12.6a5.13 5.13 0 0 0 2.7.733m5.067-3.7q.132-.383.2-.791.066-.409.066-.842 0-1.867-1.133-3.292a5.27 5.27 0 0 0-2.867-1.875v1.834q.55 0 .942.391.392.392.392.942v1.333q.316 0 .566.075t.484.309zM8 14.667a6.5 6.5 0 0 1-2.6-.525 6.7 6.7 0 0 1-2.117-1.425A6.7 6.7 0 0 1 1.858 10.6 6.5 6.5 0 0 1 1.333 8q0-1.383.525-2.6a6.7 6.7 0 0 1 1.425-2.117q.9-.9 2.117-1.425A6.5 6.5 0 0 1 8 1.333q1.383 0 2.6.525t2.117 1.425T14.142 5.4t.525 2.6-.525 2.6a6.7 6.7 0 0 1-1.425 2.117q-.9.9-2.117 1.425a6.5 6.5 0 0 1-2.6.525'
                />
            </mask>
            <g mask='url(#globeUKMask)'>
                <path
                    fill='#0b1627'
                    fillOpacity='.64'
                    d='M0 0h16v16H0z'
                />
            </g>
        </SvgElement>
    );
});
